// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"f93f12ed","320":"5bd011fd","336":"6f1c90b9","385":"0a4a8387","453":"6162beab"}[chunkId] + ".chunk.js";
};